import { render, staticRenderFns } from "./PIA.vue?vue&type=template&id=9c9161c4&scoped=true"
import script from "./PIA.vue?vue&type=script&lang=js"
export * from "./PIA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9161c4",
  null
  
)

export default component.exports